import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';

import { useHistory } from 'stores/hooks';

/**
 * We use recommended solution proposed by react-router team, but instead of using (react-router).useLocation() we
 * add listener to our history object.
 */
function ScrollToTop() {
  const history = useHistory();
  const [pathname, setPathname] = useState('');

  const unregisterRef = useRef<() => void>();

  const historyListener = (location: string, action: 'PUSH' | 'POP' | 'REPLACE') => {
    if (pathname !== location) {
      document.getElementById('retino')?.scroll(0, 0);
    }

    setPathname(location);
  };

  useEffect(
    () => () => {
      if (unregisterRef.current) {
        unregisterRef.current();
      }
    },
    [],
  );

  useEffect(() => {
    if (unregisterRef.current) {
      unregisterRef.current();
    }
    unregisterRef.current = history.listen(historyListener);
  }, [pathname]);

  return null;
}

export default observer(ScrollToTop);
